import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './MedHistory.module.css';
import { DBCheckBox, DBRadioButton, DBTextArea } from '_components';
import { PatientCareCenterNoteSubjectiveFunctionalDeficits } from './FunctionalDeficits';
import { PatientCareCenterNoteSubjectiveFunctionalDeficitsWC } from './FunctionalDeficitsWC';


class PatientCareCenterNoteSubjectiveMedHistory extends React.Component {

    handleClick(selected) {
        if (selected) {
            let fields = ['EVSUBMEDCOMALLERGIES',
                'EVSUBMEDCOMANGINA',
                'EVSUBMEDCOMANXIETY',
                'EVSUBMEDCOMARTHRITIS',
                'EVSUBMEDCOMASTHMA',
                'EVSUBMEDCOMBACKPAIN',
                'EVSUBMEDCOMCANCER',
                'EVSUBMEDCOMCOPD',
                'EVSUBMEDCOMHEARTDIS',
                'EVSUBMEDCOMDEPRESS',
                'EVSUBMEDCOMDIABETES',
                'EVSUBMEDCOMGASTO',
                'EVSUBMEDCOMHEADACHE',
                'EVSUBMEDCOMHEAR',
                'EVSUBMEDCOMHEARTATT',
                'EVSUBMEDCOMBLOOD',
                'EVSUBMEDCOMHIGHBP',
                'EVSUBMEDCOMINCONT',
                'EVSUBMEDCOMKIDNEY',
                'EVSUBMEDCOMNEURO',
                'EVSUBMEDCOMOSTEO',
                'EVSUBMEDCOMOTHDIS',
                'EVSUBMEDCOMPACE',
                'EVSUBMEDCOMVASC',
                'EVSUBMEDCOMPREVACC',
                'EVSUBMEDCOMSURGERY',
                'EVSUBMEDCOMPROSTHESIS',
                'EVSUBMEDCOMSEIZURE',
                'EVSUBMEDCOMSLEEPDYS',
                'EVSUBMEDCOMSTROKE',
                'EVSUBMEDCOMVISUAL',
                'EVSUBMEDCOMOTHER',
                'EVSUBMEDCOMALLERGY',
                'EVSUBMEDCOMTOBACCO'
            ];
            this.props.clearFields(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, fields);
        }
    }


    render() {
        return (
            <div>
                <div className={styles.radio_row}>
                    <label className={styles.label_col}>Dominant Arm:</label>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDDOMARM'
                        label='Left'
                        selectedValue='Left'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDDOMARM'
                        label='Right'
                        selectedValue='Right'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDDOMARM'
                        label='Both'
                        selectedValue='Both'
                        className={styles.radio_col}
                    />
                </div>

                <PatientCareCenterNoteNavAnchor id='subj_medhis_involvedside' />

                <div className={styles.radio_row} id='subj_medhis_involvedside'>
                    <label className={styles.label_col_req}>Involved Side:</label>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='Left'
                        selectedValue='Left'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='Right'
                        selectedValue='Right'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='Both'
                        selectedValue='Both'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='N/A'
                        selectedValue='N/A'
                        className={styles.radio_col}
                    />
                </div>

                {!this.props.isWc &&
                    <PatientCareCenterNoteSubjectiveFunctionalDeficits />
                }
                {this.props.isWc &&
                    <PatientCareCenterNoteSubjectiveFunctionalDeficitsWC />
                }

                <PatientCareCenterNoteSection id='sub_med_hist_comorb' name='Comorbidity' level={2} allowCollapse={false} className={styles.required}>
                    <div className={styles.checkbox_row}>
                        <span className={styles.label_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMNONE' label='None' className={styles.checkbox_col}
                            onClick={(event) => this.handleClick(event)}
                        />
                        <div className={styles.checkbox_col} />



                    </div>
                    {this.props.comorbNone === false &&
                        <div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMALLERGIES' label='Allergies' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMHIGHBP' label='High Blood Pressure' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMANGINA' label='Angina' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMINCONT' label='Incontinence' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMANXIETY' label='Anxiety or Panic Disorders' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMKIDNEY' label='Kidney, Bladder, Prostate or Urination Problems' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMARTHRITIS' label='Arthritis' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMNEURO' label='Neurological Disease' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMASTHMA' label='Asthma' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMOSTEO' label='Osteoporosis' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMBACKPAIN' label='Back Pain' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMOTHDIS' label='Other disorders' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMCANCER' label='Cancer' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMPACE' label='Pacemaker' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMCOPD' label='COPD or emphysema' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMVASC' label='Peripheral Vascular Disease' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMHEARTDIS' label='Congestive Heart Failure or Heart Disease' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMPREVACC' label='Previous accidents' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMDEPRESS' label='Depression' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMSURGERY' label='Prior Surgery' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMDIABETES' label='Diabetes Type I or II' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMPROSTHESIS' label='Prosthesis / Implants' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMGASTO' label='Gastrointestinal Disease' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMSEIZURE' label='Seizures' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMHEADACHE' label='Headaches' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMSLEEPDYS' label='Sleep dysfunction' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMHEAR' label='Hearing Impairment' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMSTROKE' label='Stroke or TIA' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMHEARTATT' label='Heart Attack' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMTOBACCO' label='Tobacco' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMBLOOD' label='Hepatitis, TB, or blood-borne condition' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMVISUAL' label='Visual Impairment' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.textarea_row}>
                                <label className={styles.label_col_top}>Other:</label>
                                <DBTextArea noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMOTHER' className={styles.textarea_col} />
                            </div>
                            {this.props.comorbAllergies &&
                                <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                                    <label className={styles.label_col_req_top}>Allergies:</label>
                                    <DBTextArea noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMALLERGY' className={styles.textarea_col} />
                                </div>
                            }
                        </div>
                    }

                </PatientCareCenterNoteSection>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let epno = state.entities.notes.PTEVAL[evno].EVEPNO;
    let isWc = state.entities.admissions[epno].isWc;

    return {
        noteId: noteId,
        evno: evno,
        comorbNone: state.entities.notes.PTEVAL[evno].EVSUBMEDCOMNONE ? state.entities.notes.PTEVAL[evno].EVSUBMEDCOMNONE : false,
        comorbAllergies: state.entities.notes.PTEVAL[evno].EVSUBMEDCOMALLERGIES ? state.entities.notes.PTEVAL[evno].EVSUBMEDCOMALLERGIES : false,
        isWc
    };
}

const connectedPatientCareCenterNoteSubjectiveMedHistory = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveMedHistory);
export { connectedPatientCareCenterNoteSubjectiveMedHistory as PatientCareCenterNoteSubjectiveMedHistory };

